import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import styled, { keyframes } from 'styled-components';
import { getRandomMessage } from "../../utils/loadingMessages";
import RandomGame from "../../component/games";

const cloudFloat = keyframes`
    0% {
        transform: translateX(540px);
        opacity: 0;
    }
    10% {
        opacity: 0.9;
    }
    90% {
        opacity: 0.9;
    }
    100% {
        transform: translateX(-200px);
        opacity: 0;
    }
`;

const cloudFloat2 = keyframes`
    0% {
        transform: translateX(-540px);
        opacity: 0;
    }
    10% {
        opacity: 0.9;
    }
    90% {
        opacity: 0.9;
    }
    100% {
        transform: translateX(540px);
        opacity: 0;
    }
`;

const Cloud = styled.img`
    position: absolute;
    top: 68%;
    width: 100%;
    max-width:60px;
    animation: ${cloudFloat} 30s linear infinite;

    @media (max-width: 520px) {
        max-width:11.5385vw;
    }
`;

const Cloud2 = styled.img`
    position: absolute;
    top: 70%;
    width: 100%;
    max-width:215px;
    animation: ${cloudFloat2} 20s linear infinite;

    @media (max-width: 520px) {
        max-width:41.3462vw;
    }
`;

const Cloud3 = styled.img`
    position: absolute;
    top: 60%;
    width: 100%;
    max-width:115px;
    animation: ${cloudFloat} 30s linear infinite;

    @media (max-width: 520px) {
        max-width:22.1154vw;
    }
`;

const Cloud4 = styled.img`
    position: absolute;
    top: 73%;
    width: 100%;
    max-width:215px;
    animation: ${cloudFloat2} 20s linear infinite;

    @media (max-width: 520px) {
        max-width:41.3462vw;
    }
`;

const Cloud5 = styled.img`
    position: absolute;
    top: 70%;
    width: 100%;
    max-width:60px;
    animation: ${cloudFloat2} 25s linear infinite;

    @media (max-width: 520px) {
        max-width:11.5385vw;
    }
`;

const LoadingMessage = styled.h5`
    font-size: 18px;
    font-weight: 800;
    margin-bottom: 15px;
    word-break: keep-all;
    line-height: 1.4;
    text-align: center;
    color: #0A1C2A;

    @media (max-width: 520px) {
        font-size: 3.4615vw;
        margin-bottom: 2.8846vw;
    }
`;

const GameSection = styled.div`
    margin-top: 10px;
    width: 100%;

    @media (max-width: 520px) {
        margin-top: 1.9231vw;
    }
`;

export default function Loading({ Constellation }) {
    const [message, setMessage] = useState(getRandomMessage());

    useEffect(() => {
        setMessage(getRandomMessage());
    }, []);

    return (
        <div className="loadingPage_daetong">
            <Cloud src={process.env.PUBLIC_URL + '/daetongImg/cloud.png'} alt="cloud"/>
            <Cloud2 src={process.env.PUBLIC_URL + '/daetongImg/cloud2.png'} alt="cloud"/>
            <Cloud5 src={process.env.PUBLIC_URL + '/daetongImg/cloud.png'} alt="cloud"/>
            <div className="loadingPageDaetong_inner">
                <div className="loadingContent_daetong">
                    <p className="content_scroll top">
                        <img src={process.env.PUBLIC_URL + '/daetongImg/content_scroll.png'} alt='' />
                    </p>
                    <p className="content_scroll bottom">
                        <img src={process.env.PUBLIC_URL + '/daetongImg/content_scroll.png'} alt='' />
                    </p>
                    <div className="loadingBox_daetong">
                        <Link to="/daetong" className="logo">
                            <img src={process.env.PUBLIC_URL + '/image/daetong_logo.png'} alt='운수대통방' />
                            <span className="line"></span>
                        </Link>
                        <LoadingMessage>{message}</LoadingMessage>
                        <GameSection>
                            <RandomGame theme="daetong" />
                        </GameSection>
                    </div>
                </div>

                <div className="mountainPeak_box">
                    <div className="mountainPeak_inner">
                        <Cloud3 src={process.env.PUBLIC_URL + '/daetongImg/cloud.png'} alt="cloud" />
                        <Cloud4 src={process.env.PUBLIC_URL + '/daetongImg/cloud2.png'} alt="cloud" />
                        <img src={process.env.PUBLIC_URL + '/daetongImg/mountain_peak.png'} alt="" />
                    </div>
                </div>
            </div>
        </div>
    )
}
